module.exports = __webpack_public_path__ + "media/images/recruitment/landing/client03-002b881d617c6ff791d3fcf5c4c48892.png";